
// EC-27 : Sub Task - 553 Cart Page 
// Start: Refactored dynamic CSS from CMS to code for consistent behavior across environments.
import { cartLineCardExpandedStyles } from "@WhiteCap/Overrides/Widgets/Cart/CartLineCardExpanded";
import { css } from "styled-components";

cartLineCardExpandedStyles.productPriceExtendedUnitNetPriceText = {
	css: css`
		font-family: inherit;
	`
}

cartLineCardExpandedStyles.extendedUnitNetPriceText  = {
	css: css`
		font-family: inherit;
		font-size: 16px;
	`
}

cartLineCardExpandedStyles.priceLabelText = {
	variant: "legend",
	css: css`
		font-family: inherit;
		text-transform: uppercase;
    	font-size: 12px;
		font-weight: 400;
	`
}

cartLineCardExpandedStyles.quantity = {
	editableQuantityTextField: {
		labelProps: {
			css: css`
				font-size: 10px;
				font-family: Gotham-Medium;
				margin-top: 0px;
				font-weight: 600;
			`,
		},
		cssOverrides: {
			formInputWrapper: css`
				margin-top: 0px !important;
			`,	
        },
	}
}

// End: Refactored dynamic CSS from CMS to code for consistent behavior across environments.